import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import { categories, comics } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  const category = categories.find((c) => c.slug === slug);
  const categoryComics = comics.filter((c) => c.category === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="pt-20 min-h-screen flex items-center justify-center">
          <p className="text-foreground-500">分类不存在</p>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
              <a href="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</a>
              <span>/</span>
              <span className="text-foreground-900 font-medium whitespace-nowrap">{category.name}韩漫</span>
            </div>

            <div className="flex items-center gap-4 mb-2">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-xl text-primary-600`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                  {category.name}韩漫
                </h1>
                <p className="text-sm text-foreground-500 mt-1">{category.description}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            {categoryComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
                {categoryComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}